import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import withFavorite from 'components/hoc/Cards/withFavorite';
import withHistoryBack from 'components/hoc/Cards/withHistoryBack';

import Card from 'components/molecules/Card';
import cardRenderLocation from 'containers/molecules/Card/enum-card-render-location';

import { generateSignature } from 'helper/signature';

import { getIsFavorite } from 'store/favorites';
import { getCurrentDayNumber } from 'store/programDays';
import { mapBackendContentType } from 'store/programItems';
import { IconMapTypeType } from 'store/programItems';
import { getCardImageFromItemContent } from 'store/programItems';
import { actionCreators } from 'store/programItems';

export const mapCategoryIcon = (type: IconMapTypeType) => {
	const iconMap = {
		slogan: 'quote',
		recommendation: 'stars',
		dynamicProduct: 'cart',
	};

	return iconMap[type] ? iconMap[type] : type;
};

const mapStateToProps = (state, ownProps) => {
	const type = mapBackendContentType(ownProps.contentType);
	const categoryIcon = mapCategoryIcon(type);
	const previewImage = getCardImageFromItemContent(ownProps);
	const favorite = getIsFavorite(state, ownProps.externalId);
	const currentDayNumber = getCurrentDayNumber(state);
	const signature = generateSignature(
		ownProps.externalId,
		categoryIcon,
		ownProps.masterChannel,
		previewImage,
		favorite
	);

	return {
		...ownProps,
		signature,
		currentDayNumber,
		contentTypeExternalId: ownProps.externalId,
		id: ownProps.externalId,
		state: 'feed',
		uiState: 'detail',
		previewImage,
		favorite,
		type,
		categoryIcon,
		isMigustoRecipe: ownProps.masterChannel === 'migusto',
		isCheckable: false,
		cardRenderLocation: cardRenderLocation.FAVORITE,
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			doToggleFavorite: actionCreators.doToggleFavorite,
		},
		dispatch
	);
};

const CardWithHistory = withHistoryBack(Card);
const CardWithFavorite = withFavorite(CardWithHistory);

export default connect(mapStateToProps, mapDispatchToProps)(CardWithFavorite);
